export const golfInsightBetaAccess = [
  1429100, // Dairy Farm
  1429742, // AA-Al Salamat P1
  1429748, // Sentosa Golf Club - Singapore
  421758, // WT dummy
]

export const scadaPreviewAccess = [
  1429100, // Dairy Farm
  1429742, // AA-Al Salamat P1
]

export const GBPumpPanelAccess = [
  1429735, // GB - Super Trees
  421758, // West Torrent Dummy
]

export const calculatedWaterUseAccess = [
  1429749, // Deogyusan GC
  1429100, // Dairy Farm
  421758, // wt dummy
]

export const ZeusDashboardAccess = [
  1429100, // Dairy Farm
  1429745, // P26 Lights Vision
  1429747, // COA - P15 King Rodney Park
  421758, // West Torrent Dummy
  1429741, // COA - P2 Prospect Rd
  1429742, // AA-Al Salamat P1
  1429601, // COA - Whitmore Square
  1429097, // Sheriff St
  1429099, // airport median
  1429102, // nelly's shack
  1429106, // council chamber
  1429714, // wt- Beare Avenue Reserve
  1429738, // WT - Frank Norton Reserve
  421771, // MW Trial
]

export const SentosaGolfAccessRestriction = [
  1429748, // Sentosa Golf Club - Singapore
]

// SCRUM-1057 - Rain report tab, Sentosa plus a test controller
export const rainReportAccess = [
  1429748, // Sentosa Golf Club - Singapore
  421758, // West Torrent Dummy
]

export const IncheonNamdongAccess = [
  1429593, // Incheon Namdong - Korea
]

export const AdelaideOvalWeatherAccess = [
  1429101, // Adelaide Oval - MO
  1429717, // Adelaide Oval - No.2 Oval
]

export const WeatherDashboardV2Access = [
  1429593, // Incheon Namdong - Korea
  1429595,
  421758, // West Torrent Dummy
  1430036,
  1430213,
  1429101, // Adelaide Oval - MO
  1429717, // Adelaide Oval - No.2 Oval
]

export const DynamicDashboardAccess = [
  1429100, // Demo Controller P1
  1429751, // GB - HQ Solar Panel Cooling
]

// SCRUM-1194 - 3D digital twin, built per building
export const DigitalTwinAccess = [
  1429964, // CapitaGreen Market Street
  1429735, // GB - Super Trees
]
